import { createContext, useContext } from 'react';

export const WishlistContext = createContext();
export const useWishlistContext = () => {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error(
      'WishlistContext compound components cannot be rendered outside the WishlistContext component',
    );
  }
  return context;
};
